import Vue from 'vue';
import {
  LIST,
  AREAS,
  FLOORS,
  MEDIAS
} from './mutation-types';

export default {

  [LIST](state, response) {
    state.stores = response.stores;
  },

  [AREAS](state, response) {
    state.areas = response.areas;
  },

  [FLOORS](state, response) {
    state.storeFloors = response.storeFloors;
  },

  [MEDIAS](state, response) {
    state.medias = response.medias;
  },

};
